export default "__VITE_ASSET__CEZeKrsA__"